import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-log-details-modal',
  templateUrl: './log-details-modal.component.html',
  styleUrls: ['./log-details-modal.component.css']
})
export class LogDetailsModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<LogDetailsModalComponent>,
  ) { }

  numberOfLinesInTextPatientExitLog: number = this.data?.numberOfLinesInTextPatientExitLog;
  formattedRequestJson: string = '';
  formattedResponseJson: string = '';

  ngOnInit(): void {
    try {
      this.formattedRequestJson = JSON.stringify(JSON.parse(this.data.logRequestDetails), null, 2);
      this.formattedResponseJson = JSON.stringify(JSON.parse(this.data.logResponseDetails), null, 2);
    } catch (e) {
      this.formattedRequestJson = this.data.logRequestDetails; // Caso não seja JSON válido, mostra como está
      this.formattedResponseJson = this.data.logResponseDetails; // Caso não seja JSON válido, mostra como está
    }
  }

  back() {
    this.matDialogRef.close();
  }
}
